<ng-template #fieldRequiredTemplate>
  <span>A mező kitöltése kötelező!</span>
</ng-template>

<payee-popup
  title="Partner létrehozása"
  width="560px"
  [description]="!partnerToken ? '' : 'A Partner Token-t másold ki most, mert késöbb nem lesz látható!'"
>
  @if (!partnerToken) {
    <form
      class="main-form"
      [formGroup]="formGroup"
    >
      <payee-form-field width="max">
        <input
          type="text"
          payee-input
          formControlName="name"
        />
        <span payee-label>Partner neve</span>
        @if (name.invalid && name.dirty) {
          <ng-container payee-error>
            @if (name.hasError("required")) {
              <ng-template [ngTemplateOutlet]="fieldRequiredTemplate"></ng-template>
            }
            @if (name.hasError("unknown")) {
              <span>
                {{ name.getError("unknown") }}
              </span>
            }
          </ng-container>
        }
      </payee-form-field>
      <payee-form-field width="max">
        <input
          type="text"
          payee-input
          formControlName="integration"
        />
        <span payee-label>Partner Azonosítója</span>
        @if (integration.invalid && integration.dirty) {
          <ng-container payee-error>
            @if (integration.hasError("required")) {
              <ng-template [ngTemplateOutlet]="fieldRequiredTemplate"></ng-template>
            }
            @if (integration.hasError("unknown")) {
              <span>
                {{ integration.getError("unknown") }}
              </span>
            }
          </ng-container>
        }
      </payee-form-field>
      <payee-form-field width="max">
        <input
          type="text"
          payee-input
          formControlName="origin"
        />
        <span payee-label>Partner Originja</span>
        @if (origin.invalid && origin.dirty) {
          <ng-container payee-error>
            @if (origin.hasError("required")) {
              <ng-template [ngTemplateOutlet]="fieldRequiredTemplate"></ng-template>
            }
            @if (origin.hasError("unknown")) {
              <span>
                {{ origin.getError("unknown") }}
              </span>
            }
          </ng-container>
        }
      </payee-form-field>

      <div class="partner-logo-fields flex">
        <div class="logo-field flex column">
          <span class="logo-label">Form logó</span>
          <div class="logo-slot">
            @if (formLogoPreview) {
              <img
                class="logo-preview"
                alt=""
                [src]="formLogoPreview"
              />
              <button
                payee-mini-icon-button
                type="button"
                color="white"
                class="remove-logo"
                (click)="removeLogo('formLogo')"
              >
                <payee-icon name="trash-red"></payee-icon>
              </button>
            } @else {
              <payee-dropzone
                title=""
                description=""
                [accept]="logoAccept"
                [multiple]="false"
                (dropped)="filesDropped('formLogo', $event)"
              ></payee-dropzone>
            }
          </div>
        </div>

        <div class="logo-field flex column">
          <span class="logo-label">Kis logó</span>
          <div class="logo-slot">
            @if (smallLogoPreview) {
              <img
                class="logo-preview"
                alt=""
                [src]="smallLogoPreview"
              />
              <button
                payee-mini-icon-button
                type="button"
                color="white"
                class="remove-logo"
                (click)="removeLogo('smallLogo')"
              >
                <payee-icon name="trash-red"></payee-icon>
              </button>
            } @else {
              <payee-dropzone
                title=""
                description=""
                [accept]="logoAccept"
                [multiple]="false"
                (dropped)="filesDropped('smallLogo', $event)"
              ></payee-dropzone>
            }
          </div>
        </div>

        <div class="logo-field flex column">
          <span class="logo-label">Workflow logó</span>
          <div class="logo-slot">
            @if (workflowNotificationLogoPreview) {
              <img
                class="logo-preview"
                alt=""
                [src]="workflowNotificationLogoPreview"
              />
              <button
                payee-mini-icon-button
                type="button"
                color="white"
                class="remove-logo"
                (click)="removeLogo('workflowNotificationLogo')"
              >
                <payee-icon name="trash-red"></payee-icon>
              </button>
            } @else {
              <payee-dropzone
                title=""
                description=""
                [accept]="logoAccept"
                [multiple]="false"
                (dropped)="filesDropped('workflowNotificationLogo', $event)"
              ></payee-dropzone>
            }
          </div>
        </div>
      </div>

      @if (formGroup.hasError("unknown")) {
        <span color="alert-red">
          {{ formGroup.getError("unknown") }}
        </span>
      }
    </form>
  }

  @if (!!partnerToken) {
    <div>
      <div>Partner neve: {{ name.value }}</div>
      <div>Partner azonosítója: {{ integration.value }}</div>
      <div>Partner originja: {{ origin.value }}</div>
      <input
        #partnerTokenInput
        hidden
        [value]="partnerToken"
      />
      <div class="flex vcenter">
        <span>Partner Token: {{ partnerToken }}</span>
        <button
          payee-copy-button
          [input]="partnerTokenInput"
        >
          <span hidden>Másolás</span>
        </button>
      </div>
    </div>
  }

  <ng-template #payeePopupSubmitTemplate>
    @if (!partnerToken) {
      <button
        payee-button
        width="max"
        [disabled]="formGroup.invalid"
        (click)="submit()"
      >
        Mentés
      </button>
    }
    @if (!!partnerToken) {
      <button
        payee-button
        width="max"
        [mat-dialog-close]="true"
      >
        Bezárás
      </button>
    }
  </ng-template>
  <ng-template #payeePopupCancelTemplate>
    @if (!partnerToken) {
      <button
        payee-button
        color="alert-red"
        width="max"
        [mat-dialog-close]="false"
      >
        Mégse
      </button>
    }
  </ng-template>
</payee-popup>
